import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileComplete, setProfileComplete] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await api.get('/auth/user');
      setUser(response.data.user);
      
      if (response.data.user) {
        await checkProfileComplete();
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setUser(null);
      setProfileComplete(true);
    } finally {
      setLoading(false);
    }
  };

  const checkProfileComplete = async () => {
    try {
      const response = await api.get('/user/profile');
      const profile = response.data;
      setUserProfile(profile);
      
      const isComplete = !!(profile.name && profile.email && profile.mobile_number);
      setProfileComplete(isComplete);
    } catch (error) {
      console.error('Profile check failed:', error);
      setProfileComplete(true);
    }
  };

  const refreshUser = async () => {
    await checkProfileComplete();
  };

  const login = () => {
    window.location.href = '/api/auth/login';
  };

  const logout = () => {
    window.location.href = '/api/auth/logout';
  };

  const value = {
    user,
    userProfile,
    loading,
    isAuthenticated: !!user,
    profileComplete,
    login,
    logout,
    checkAuth,
    refreshUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
